import React from 'react';
import './App.css';
import Paycard from './pages/Paycard/Paycard.page'

const App = () => {
  return (
    <div className="App">
      <Paycard />
    </div>
  );
}

export default App;
